import Global from '../../../store/global-selectors';

const getSalesOrderIdsForGridId = (state, gridId) => {
  const fulfillmentPlan = Global.selectEntitiesFulfillmentPlanById(state, {
    fulfillmentPlanId: gridId,
  });
  if (fulfillmentPlan) {
    return fulfillmentPlan.salesOrdersFulfilledIds;
  }

  const salesOrder = Global.selectEntitiesSalesOrderById(state, {
    salesOrderId: gridId,
  });
  if (salesOrder) {
    return [gridId];
  }

  return [];
};

const getUniqueGridSalesOrderIds = (state) => {
  const gridIds = Global.selectOrdersGridOrders(state) || [];
  const gridSalesOrderIds = gridIds.reduce((acc, gridId) => {
    return acc.concat(getSalesOrderIdsForGridId(state, gridId));
  }, []);

  return Array.from(new Set(gridSalesOrderIds));
};

const getPreviousAndNextSalesOrderOrderIds = (state, salesOrderId) => {
  const uniqueGridSalesOrderIds = getUniqueGridSalesOrderIds(state);
  for (let i = 0; i < uniqueGridSalesOrderIds.length; i++) {
    const gridSalesOrderId = uniqueGridSalesOrderIds[i];
    if (gridSalesOrderId === salesOrderId) {
      return {
        currentOrderIndex: i,
        previousOrderId: uniqueGridSalesOrderIds[i - 1] || null,
        nextOrderId: uniqueGridSalesOrderIds[i + 1] || null,
      };
    }
  }
  return { currentOrderIndex: -1 };
};

export const composeOrderDetailsNavigationParameters = (state, salesOrderId) => {
  const { previousOrderId, nextOrderId, currentOrderIndex } = getPreviousAndNextSalesOrderOrderIds(state, salesOrderId);
  const showArrows = currentOrderIndex !== -1 && !window.location.pathname.includes('/shipments');
  const canGoToPreviousOrder = showArrows && !!previousOrderId;
  const canGoToNextOrder = showArrows && !!nextOrderId;

  return {
    showArrows,
    canGoToPreviousOrder,
    canGoToNextOrder,
    previousOrderId,
    nextOrderId,
  };
};
